<template>
    <div class="loader">Loading...</div>
</template>

<script>
  export default {
    name: 'AppLoader',
  };
</script>

<style scoped lang="scss">
    $color: #22313a;
    $opacity: 0.2;

    .loader {
        margin: 100px auto;
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
        position: relative;
        text-indent: -9999em;
        -webkit-animation: load 1.1s infinite ease;
        animation: load 1.1s infinite ease;
        -webkit-transform: translateZ(0);
        -ms-transform: translateZ(0);
        transform: translateZ(0);
    }

    @-webkit-keyframes load {
        0%,
        100% {
            box-shadow: 0 -2.6em 0 0 $color, 1.8em -1.8em 0 0 rgba($color, 0.2), 2.5em 0 0 0 rgba($color, 0.2), 1.75em 1.75em 0 0 rgba($color, 0.2), 0 2.5em 0 0 rgba($color, 0.2), -1.8em 1.8em 0 0 rgba($color, 0.2), -2.6em 0 0 0 rgba($color, 0.5), -1.8em -1.8em 0 0 rgba($color, 0.7);
        }
        12.5% {
            box-shadow: 0 -2.6em 0 0 rgba($color, 0.7), 1.8em -1.8em 0 0 $color, 2.5em 0 0 0 rgba($color, 0.2), 1.75em 1.75em 0 0 rgba($color, 0.2), 0 2.5em 0 0 rgba($color, 0.2), -1.8em 1.8em 0 0 rgba($color, 0.2), -2.6em 0 0 0 rgba($color, 0.2), -1.8em -1.8em 0 0 rgba($color, 0.5);
        }
        25% {
            box-shadow: 0 -2.6em 0 0 rgba($color, 0.5), 1.8em -1.8em 0 0 rgba($color, 0.7), 2.5em 0 0 0 $color, 1.75em 1.75em 0 0 rgba($color, 0.2), 0 2.5em 0 0 rgba($color, 0.2), -1.8em 1.8em 0 0 rgba($color, 0.2), -2.6em 0 0 0 rgba($color, 0.2), -1.8em -1.8em 0 0 rgba($color, 0.2);
        }
        37.5% {
            box-shadow: 0 -2.6em 0 0 rgba($color, 0.2), 1.8em -1.8em 0 0 rgba($color, 0.5), 2.5em 0 0 0 rgba($color, 0.7), 1.75em 1.75em 0 0 $color, 0 2.5em 0 0 rgba($color, 0.2), -1.8em 1.8em 0 0 rgba($color, 0.2), -2.6em 0 0 0 rgba($color, 0.2), -1.8em -1.8em 0 0 rgba($color, 0.2);
        }
        50% {
            box-shadow: 0 -2.6em 0 0 rgba($color, 0.2), 1.8em -1.8em 0 0 rgba($color, 0.2), 2.5em 0 0 0 rgba($color, 0.5), 1.75em 1.75em 0 0 rgba($color, 0.7), 0 2.5em 0 0 $color, -1.8em 1.8em 0 0 rgba($color, 0.2), -2.6em 0 0 0 rgba($color, 0.2), -1.8em -1.8em 0 0 rgba($color, 0.2);
        }
        62.5% {
            box-shadow: 0 -2.6em 0 0 rgba($color, 0.2), 1.8em -1.8em 0 0 rgba($color, 0.2), 2.5em 0 0 0 rgba($color, 0.2), 1.75em 1.75em 0 0 rgba($color, 0.5), 0 2.5em 0 0 rgba($color, 0.7), -1.8em 1.8em 0 0 $color, -2.6em 0 0 0 rgba($color, 0.2), -1.8em -1.8em 0 0 rgba($color, 0.2);
        }
        75% {
            box-shadow: 0 -2.6em 0 0 rgba($color, 0.2), 1.8em -1.8em 0 0 rgba($color, 0.2), 2.5em 0 0 0 rgba($color, 0.2), 1.75em 1.75em 0 0 rgba($color, 0.2), 0 2.5em 0 0 rgba($color, 0.5), -1.8em 1.8em 0 0 rgba($color, 0.7), -2.6em 0 0 0 $color, -1.8em -1.8em 0 0 rgba($color, 0.2);
        }
        87.5% {
            box-shadow: 0 -2.6em 0 0 rgba($color, 0.2), 1.8em -1.8em 0 0 rgba($color, 0.2), 2.5em 0 0 0 rgba($color, 0.2), 1.75em 1.75em 0 0 rgba($color, 0.2), 0 2.5em 0 0 rgba($color, 0.2), -1.8em 1.8em 0 0 rgba($color, 0.5), -2.6em 0 0 0 rgba($color, 0.7), -1.8em -1.8em 0 0 $color;
        }
    }

    @keyframes load {
        0%,
        100% {
            box-shadow: 0 -2.6em 0 0 $color, 1.8em -1.8em 0 0 rgba($color, 0.2), 2.5em 0 0 0 rgba($color, 0.2), 1.75em 1.75em 0 0 rgba($color, 0.2), 0 2.5em 0 0 rgba($color, 0.2), -1.8em 1.8em 0 0 rgba($color, 0.2), -2.6em 0 0 0 rgba($color, 0.5), -1.8em -1.8em 0 0 rgba($color, 0.7);
        }
        12.5% {
            box-shadow: 0 -2.6em 0 0 rgba($color, 0.7), 1.8em -1.8em 0 0 $color, 2.5em 0 0 0 rgba($color, 0.2), 1.75em 1.75em 0 0 rgba($color, 0.2), 0 2.5em 0 0 rgba($color, 0.2), -1.8em 1.8em 0 0 rgba($color, 0.2), -2.6em 0 0 0 rgba($color, 0.2), -1.8em -1.8em 0 0 rgba($color, 0.5);
        }
        25% {
            box-shadow: 0 -2.6em 0 0 rgba($color, 0.5), 1.8em -1.8em 0 0 rgba($color, 0.7), 2.5em 0 0 0 $color, 1.75em 1.75em 0 0 rgba($color, 0.2), 0 2.5em 0 0 rgba($color, 0.2), -1.8em 1.8em 0 0 rgba($color, 0.2), -2.6em 0 0 0 rgba($color, 0.2), -1.8em -1.8em 0 0 rgba($color, 0.2);
        }
        37.5% {
            box-shadow: 0 -2.6em 0 0 rgba($color, 0.2), 1.8em -1.8em 0 0 rgba($color, 0.5), 2.5em 0 0 0 rgba($color, 0.7), 1.75em 1.75em 0 0 $color, 0 2.5em 0 0 rgba($color, 0.2), -1.8em 1.8em 0 0 rgba($color, 0.2), -2.6em 0 0 0 rgba($color, 0.2), -1.8em -1.8em 0 0 rgba($color, 0.2);
        }
        50% {
            box-shadow: 0 -2.6em 0 0 rgba($color, 0.2), 1.8em -1.8em 0 0 rgba($color, 0.2), 2.5em 0 0 0 rgba($color, 0.5), 1.75em 1.75em 0 0 rgba($color, 0.7), 0 2.5em 0 0 $color, -1.8em 1.8em 0 0 rgba($color, 0.2), -2.6em 0 0 0 rgba($color, 0.2), -1.8em -1.8em 0 0 rgba($color, 0.2);
        }
        62.5% {
            box-shadow: 0 -2.6em 0 0 rgba($color, 0.2), 1.8em -1.8em 0 0 rgba($color, 0.2), 2.5em 0 0 0 rgba($color, 0.2), 1.75em 1.75em 0 0 rgba($color, 0.5), 0 2.5em 0 0 rgba($color, 0.7), -1.8em 1.8em 0 0 $color, -2.6em 0 0 0 rgba($color, 0.2), -1.8em -1.8em 0 0 rgba($color, 0.2);
        }
        75% {
            box-shadow: 0 -2.6em 0 0 rgba($color, 0.2), 1.8em -1.8em 0 0 rgba($color, 0.2), 2.5em 0 0 0 rgba($color, 0.2), 1.75em 1.75em 0 0 rgba($color, 0.2), 0 2.5em 0 0 rgba($color, 0.5), -1.8em 1.8em 0 0 rgba($color, 0.7), -2.6em 0 0 0 $color, -1.8em -1.8em 0 0 rgba($color, 0.2);
        }
        87.5% {
            box-shadow: 0 -2.6em 0 0 rgba($color, 0.2), 1.8em -1.8em 0 0 rgba($color, 0.2), 2.5em 0 0 0 rgba($color, 0.2), 1.75em 1.75em 0 0 rgba($color, 0.2), 0 2.5em 0 0 rgba($color, 0.2), -1.8em 1.8em 0 0 rgba($color, 0.5), -2.6em 0 0 0 rgba($color, 0.7), -1.8em -1.8em 0 0 $color;
        }
    }
</style>
